export default __webpack_public_path__ + "static/cc-white-logo-9957af3289ff0cb3297930378840aa67.png";